import type { Tuition as TuitionData } from '@mathflat/domain/Tuition'

import { EMPTY_NUMBER_ID } from '@/constant/common'

import { Day } from '../common/Calendar/Day'
import { DTO } from '../DTO'

type constructorParams = Pick<
  TuitionData,
  'studentId' | 'paymentDate' | 'lessonStartDate' | 'lessonEndDate'
> &
  Partial<Pick<TuitionData, 'id' | 'fee' | 'memo'>>

export class Tuition extends DTO {
  id = EMPTY_NUMBER_ID
  lessonStartDate: TuitionData['lessonStartDate'] = null
  lessonEndDate: TuitionData['lessonEndDate'] = null
  fee = 0
  memo = ''
  studentId: TuitionData['studentId']
  paymentDate: TuitionData['paymentDate']

  constructor({ studentId, paymentDate, memo, ...data }: constructorParams) {
    super()
    this.studentId = studentId
    this.paymentDate = paymentDate
    this.memo = memo ?? ''
    this.update<Tuition>(data)
  }

  get paymentDay() {
    return new Day(this.paymentDate)
  }
}

export default Tuition
